module.exports = __webpack_public_path__ + "static/media/tessa.03111dfe.jpg";